import IApplicationState from 'app/types/state';

export function getCurrentAddress(state: IApplicationState) {
  if (
    state.addresses.addressesById !== undefined
    && state.addresses.currentAddressId !== undefined
  ) {
    return state.addresses.addressesById[Object.keys(state.addresses.addressesById)[0]];
  }
  return {};
}

export function getCurrentFormAddress(state: IApplicationState) {
  return {
    ...getCurrentAddress(state),
    ...state.addresses.requestedData,
  };
}

export function getAddresses(state: IApplicationState) {
  return {
    ...state.addresses,
    currentAddress: getCurrentAddress(state),
    currentFormAddress: getCurrentFormAddress(state),
  };
}
